import { render, staticRenderFns } from "./DialogDetail.vue?vue&type=template&id=45f82164"
import script from "./DialogDetail.vue?vue&type=script&lang=js"
export * from "./DialogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports